import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import customizeHomepageUseCaseV2 from '../../factories/v2/customizeHomepage';

export const useCreateHomepageSectionV2 = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: customizeHomepageUseCaseV2.create,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['homepageConfigurationV2'] });
    },
    onError: (error) => {
      console.error('Failed to create homepage configuration:', error);
    },
  });

  return mutation;
};

export const useGetHomepageConfigurationV2 = (options = {}) => {
  const query = useQuery({
    queryKey: ['homepageConfigurationV2'],
    queryFn: customizeHomepageUseCaseV2.get,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
    ...options,
  });

  return query;
};

export const useDeleteHomepageSectionV2 = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: customizeHomepageUseCaseV2.deleteSection,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['homepageConfigurationV2'] });
    },
    onError: (error) => {
      console.error('Failed to delete homepage section:', error);
    },
  });

  return mutation;
};

export const useSortHomepageSectionsV2 = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: customizeHomepageUseCaseV2.sortSections,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['homepageConfigurationV2'] });
    },
    onError: (error) => {
      console.error('Failed to reorder homepage sections:', error);
    },
  });

  return mutation;
};

export const useUpdateHomepageSectionV2 = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ sectionId, payload }) =>
      customizeHomepageUseCaseV2.updateSection(sectionId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['homepageConfigurationV2'] });
    },
    onError: (error) => {
      console.error('Failed to update homepage section:', error);
    },
  });

  return mutation;
};

export const useUpdateHomepageSectionActiveStateV2 = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ sectionId, isActive }) =>
      customizeHomepageUseCaseV2.updateSectionActiveState(sectionId, isActive),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['homepageConfigurationV2'] });
    },
    onError: (error) => {
      console.error('Failed to update homepage section active state:', error);
    },
  });
  return mutation;
};
